import { render, staticRenderFns } from "./ShopPicker.vue?vue&type=template&id=4dcdbff6&"
import script from "./ShopPicker.vue?vue&type=script&lang=js&"
export * from "./ShopPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports